import * as Yup from 'yup'

export const ProjectDetailsSchema = Yup.object().shape({
  total_budget: Yup.number().required('Budget is required'),
  total_hours: Yup.number().required('Total hours is required'),
  description: Yup.string(),
  hourly_cost: Yup.number(),
  start_date: Yup.string(),
  end_date: Yup.string().test(
    'is-after-start',
    'End date cannot be before start date',
    function (value) {
      const { start_date } = this.parent
      if (!value || !start_date) return true
      return new Date(value) >= new Date(start_date)
    }
  ),
})
